import { cn } from '@utils/cn';

import { Icon } from '../Icon';

import type { SwitchProps } from './Switch.types';

import {
  boxClasses,
  circleBgClasses,
  circleClasses,
  circleIconClasses,
  wrapperClasses
} from './Switch.styles';

const Switch = ({ className, checked = false, disabled = false, onChange }: SwitchProps) => {
  const handleSwitchChange = () => {
    if (!disabled) onChange?.(!checked);
  };

  return (
    <label className={cn(wrapperClasses, className)}>
      <span className="sr-only">Toggle</span>
      <div className={boxClasses}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={handleSwitchChange}
          className="sr-only"
        />
        <div className={cn(circleBgClasses({ checked, disabled }))}>
          {checked && <Icon name="CheckSimple" size="small" className={cn(circleIconClasses())} />}
        </div>
        <div className={cn(circleClasses({ checked, disabled }))}></div>
      </div>
    </label>
  );
};

export { Switch };
